import { Markets } from '@shared/config/market/market.models';

export const KLARNA_SUPPORTED_MARKETS: number[] = [
    Markets.NORWAY,
    Markets.FINLAND,
    Markets.GERMANY,
];
export const LEABANK_SUPPORTED_MARKETS: number[] = [Markets.SWEDEN];
